import TextInput from '@/components/refinedev/TextInput';
import Section from '@/components/surface/Section';
import {PermissionInput} from './permission-input';

const RoleForm = () => {
  return (
    <div className="flex flex-col gap-y-4">
      <Section title="Thông tin chung" subtitle="Nhập thông tin chung">
        <TextInput source="name" label="Tên vai trò/phân quyền" />
        <TextInput source="desc" label="Mô tả" />
      </Section>
      <Section title="Phân quyền" subtitle="Phân quyền quản lý">
        <PermissionInput source="permissions" />
      </Section>
    </div>
  );
};

export const transformBeforeSave = inputData => {
  const data = {
    ...inputData,
    permissions: (inputData?.permissions || []).map(p => p.id),
  };
  return data;
};

RoleForm.transformBeforeSave = transformBeforeSave;

export default RoleForm;
